export const DEFAULT_DRAWER_WIDTH = 1134;
export const MAX_DRAWER_WDITH = 1500;
export const MIN_DRAWER_WIDTH = 1082;
